import { create } from 'zustand';
import { DEFAULT_THEME, type ThemeName } from '@domain/models/theme.enum';

const STORAGE_KEY = 'dcl.theme';

function readInitialTheme(): ThemeName {
  if (typeof window === 'undefined') {
    return DEFAULT_THEME;
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'clinical' || stored === 'aurora') {
    return stored;
  }
  const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
  return prefersDark ? 'aurora' : 'clinical';
}

type ThemeState = {
  readonly theme: ThemeName;
  readonly setTheme: (theme: ThemeName) => void;
  /** Hydrate from the authenticated user's server-side profile. */
  readonly hydrateFromProfile: (theme: ThemeName) => void;
};

export const useThemeStore = create<ThemeState>((set) => ({
  theme: readInitialTheme(),
  setTheme: (theme) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, theme);
    }
    set({ theme });
  },
  hydrateFromProfile: (theme) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, theme);
    }
    set({ theme });
  },
}));
